/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TenantGatewayTransaction from './tenant-gateway-transaction';
import TenantGatewayTransactionDetail from './tenant-gateway-transaction-detail';
import TenantGatewayTransactionUpdate from './tenant-gateway-transaction-update';
import TenantGatewayTransactionDeleteDialog from './tenant-gateway-transaction-delete-dialog';

const TenantGatewayTransactionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TenantGatewayTransaction />} />
    <Route path="new" element={<TenantGatewayTransactionUpdate />} />
    <Route path=":id">
      <Route index element={<TenantGatewayTransactionDetail />} />
      <Route path="edit" element={<TenantGatewayTransactionUpdate />} />
      <Route path="delete" element={<TenantGatewayTransactionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TenantGatewayTransactionRoutes;
